export const environment = {
  production: true,
  analytics: false,
  amazonAwsBucketName: 'staging-bit4m',
  amazonAwsBucketNamePlaceholder: '{bucketname-placeholder}',
  analyticsTag: '',
  googleMapsApiKey: 'AIzaSyB3Pc9egdsPP5OMXzYxWywnRJ1g5QqIuCA',
  cdnAddress: 'files.lobbit.app'
};
